'use client'

import type { UseProductQuantityPickerProps } from '@maestro/commerce-blocks/components/product-quantity-picker/product-quantity-picker.types'

import { useCallback, useState } from 'react'

export const useProductQuantityPicker = ({
  quantity,
  minQuantity,
  maxQuantity,
  onQuantityChange,
}: UseProductQuantityPickerProps) => {
  const [showMessage, setShowMessage] = useState(false)

  const commitQuantity = useCallback(
    (value: number) => {
      const clamped = Math.min(maxQuantity, Math.max(minQuantity, value))
      setShowMessage(value > maxQuantity)
      if (clamped !== quantity) {
        onQuantityChange(clamped)
      }
      return clamped
    },
    [maxQuantity, minQuantity, onQuantityChange, quantity]
  )

  return { commitQuantity, showMessage }
}
